{
  "version": 1,
  "asset_id": "ea968578-26ca-4e50-8c2c-15afda8e403c",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/ea968578-26ca-4e50-8c2c-15afda8e403c/hvac-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/ea968578-26ca-4e50-8c2c-15afda8e403c/hvac-card.webp",
  "original_filename": "hvac-card.webp",
  "size": 28158,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:37Z"
}
